import { Breakpoint, type SliderConfig } from '@jsmdg/yoshi';

type ConfigType = {
    [key in Breakpoint]: SliderConfig;
};

export const productSliderConfig: ConfigType = {
    [Breakpoint.XL]: {
        spaceBetween: 30,
        slidesPerView: 4,
        slidesPerGroup: 4,
        showPagination: true,
        showNavigation: true,
    },
    [Breakpoint.LG]: {
        spaceBetween: 30,
        slidesPerView: 4,
        slidesPerGroup: 4,
        showPagination: true,
        showNavigation: true,
    },
    [Breakpoint.MD]: {
        spaceBetween: 30,
        slidesPerView: 4,
        slidesPerGroup: 4,
        showPagination: true,
        showNavigation: true,
    },
    [Breakpoint.SM]: {
        spaceBetween: 30,
        slidesPerView: 3,
        slidesPerGroup: 3,
        showPagination: true,
        showNavigation: true,
    },
    [Breakpoint.XS]: {
        spaceBetween: 12,
        slidesPerView: 3,
        slidesPerGroup: 3,
        showPagination: true,
        showNavigation: true,
    },
    [Breakpoint['2XS']]: {
        spaceBetween: 12,
        slidesPerView: 2,
        slidesPerGroup: 2,
        showPagination: false,
        showNavigation: true,
    },
    [Breakpoint['3XS']]: {
        spaceBetween: 12,
        slidesPerView: 2,
        slidesPerGroup: 2,
        showPagination: false,
        showNavigation: true,
    },
};
